module.exports = __webpack_public_path__ + "static/img/foot_bg.1e67ab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/foot_bg.png
// module id = vHzm
// module chunks = 8